import { ErrorText } from "../elements/Elements";
import { OptionItem } from "./QuickActions";

export const SelectView = ({
  value,
  options,
  listItem: Item = OptionItem,
  onSelect,
  error,
}: {
  options: any[];
  listItem?: any;
  value?: any;
  onSelect?: (value: any) => void;
  error?: string;
}) => {
  return (
    <div className="x100">
      <div className="flexCenter gap20">
        {options.map((v, i) => {
          const { value: itemValue, label } = v || {};
          const selected = value === (itemValue || label);
          return (
            <div key={i} onClick={() => onSelect?.(itemValue || label)}>
              <Item data={v} selected={selected} />
            </div>
          );
        })}
      </div>
      <div className="textCenter">
        <ErrorText>{error}</ErrorText>
      </div>
    </div>
  );
};
